import { render, staticRenderFns } from "./PictureBook.vue?vue&type=template&id=024a7eab&"
import script from "./PictureBook.vue?vue&type=script&lang=js&"
export * from "./PictureBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports